"use strict";

const $ = jQuery;
const boostrap = window.bootstrap;

module.exports = class {
    #siteHeader;

    $topBarDropdownsContainer;
    $bottomBarDropdownsContainer;

    membersDropdownToggle;
    $membersDropdownToggle;
    $membersDropdown;

    exploreOurPlansDropdownToggle;
    $exploreOurPlansDropdownToggle;
    $exploreOurPlansDropdown;

    whatWeOfferDropdownToggle;
    $whatWeOfferDropdownToggle;
    $whatWeOfferDropdown;

    aboutEssenceDropdownToggle;
    $aboutEssenceDropdownToggle;
    $aboutEssenceDropdown;

    medicare101DropdownToggle;
    $medicare101DropdownToggle;
    $medicare101Dropdown;

    $searchForm;
    $searchFormToggle;

    activeToggle;

	constructor(args) {
        this.#siteHeader = args.siteHeader ?? null;

        if (!this.#siteHeader) {
            return null;
        }

		this.$topBarDropdownsContainer = this.#siteHeader.$topBar.find('.dropdown-menus-container');
        this.$bottomBarDropdownsContainer = this.#siteHeader.$bottomBar.find('.dropdown-menus-container');

        this.$membersDropdownToggle = this.#siteHeader.$topBar.find('#for-members-dropdown-toggle');
        this.$membersDropdown = this.#siteHeader.$topBar.find('#for-members-dropdown');
        this.membersDropdownToggle = new bootstrap.Dropdown(this.$membersDropdownToggle);
        this.$topBarDropdownsContainer.append(this.$membersDropdown);

        this.$exploreOurPlansDropdownToggle = this.#siteHeader.$bottomBar.find('#explore-our-plans-dropdown-toggle');
        this.$exploreOurPlansDropdown = this.#siteHeader.$bottomBar.find('#explore-our-plans-dropdown');
        this.exploreOurPlansDropdownToggle = new bootstrap.Dropdown(this.$exploreOurPlansDropdownToggle);
        this.$bottomBarDropdownsContainer.append(this.$exploreOurPlansDropdown);

        this.$whatWeOfferDropdownToggle = this.#siteHeader.$bottomBar.find('#what-we-offer-dropdown-toggle');
        this.$whatWeOfferDropdown = this.#siteHeader.$bottomBar.find('#what-we-offer-dropdown');
        this.whatWeOfferDropdownToggle = new bootstrap.Dropdown(this.$whatWeOfferDropdownToggle);
        this.$bottomBarDropdownsContainer.append(this.$whatWeOfferDropdown);

        this.$aboutEssenceDropdownToggle = this.#siteHeader.$bottomBar.find('#about-essence-dropdown-toggle');
        this.$aboutEssenceDropdown = this.#siteHeader.$bottomBar.find('#about-essence-dropdown');
        this.aboutEssenceDropdownToggle = new bootstrap.Dropdown(this.$aboutEssenceDropdownToggle);
        this.$bottomBarDropdownsContainer.append(this.$aboutEssenceDropdown);
        
        this.$medicare101DropdownToggle = this.#siteHeader.$bottomBar.find('#medicare-101-dropdown-toggle');
        this.$medicare101Dropdown = this.#siteHeader.$bottomBar.find('#medicare-101-dropdown');
        this.medicare101DropdownToggle = new bootstrap.Dropdown(this.$medicare101DropdownToggle);
        this.$bottomBarDropdownsContainer.append(this.$medicare101Dropdown);

        this.$searchForm = this.#siteHeader.$topBar.find('.search-form')
        this.$searchFormToggle = this.$searchForm.find('button');

        this.bind();
	}

    bind() {
        this.$membersDropdownToggle
            .on('show.bs.dropdown', (event) => { return this.onShowDropdown(event, { $thisToggle: this.$membersDropdownToggle }); })
            .on('hide.bs.dropdown', (event) => { return this.onHideDropdown(event, { $thisToggle: this.$membersDropdownToggle }); });

        this.$exploreOurPlansDropdownToggle
            .on('show.bs.dropdown', (event) => { return this.onShowDropdown(event, { $thisToggle: this.$exploreOurPlansDropdownToggle }); })
            .on('hide.bs.dropdown', (event) => { return this.onHideDropdown(event, { $thisToggle: this.$exploreOurPlansDropdownToggle }); });
        
        this.$whatWeOfferDropdownToggle
            .on('show.bs.dropdown', (event) => { return this.onShowDropdown(event, { $thisToggle: this.$whatWeOfferDropdownToggle }); })
            .on('hide.bs.dropdown', (event) => { return this.onHideDropdown(event, { $thisToggle: this.$whatWeOfferDropdownToggle }); });
        
        this.$aboutEssenceDropdownToggle
            .on('show.bs.dropdown', (event) => { return this.onShowDropdown(event, { $thisToggle: this.$aboutEssenceDropdownToggle }); })
            .on('hide.bs.dropdown', (event) => { return this.onHideDropdown(event, { $thisToggle: this.$aboutEssenceDropdownToggle }); });

        this.$medicare101DropdownToggle
            .on('show.bs.dropdown', (event) => { return this.onShowDropdown(event, { $thisToggle: this.$medicare101DropdownToggle }); })
            .on('hide.bs.dropdown', (event) => { return this.onHideDropdown(event, { $thisToggle: this.$medicare101DropdownToggle }); });
        
        this.$searchForm.on('submit', (event) => { return this.onSearchFormSubmit(event); });
        this.$searchFormToggle.on('click', (event) => { return this.onSearchFormToggleClick(event); });

        this.siteHeader.$header.find('a').on('click', (event) => { return this.onHeaderLinkClick(event); });
    }

    get $html() {
        return this.#siteHeader.$html;
    }
    get siteHeader() {
        return this.#siteHeader;
    }

    onShowDropdown(event, data) {
        this.activeToggle = data.$thisToggle;
        this.$html.addClass('jumbo-menu-dropdown-open');
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'header_menu_open_dropdown' }}));
    }

    onHideDropdown(event, data) {
        if (this.activeToggle.is(data.$thisToggle)) {
            this.$html.removeClass('jumbo-menu-dropdown-open');
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'header_menu_close_dropdown' }}));
    }

    onHeaderLinkClick(event) {
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'header_link_click' }}));
    }

    onSearchFormSubmit(event) {
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'search' }}));
    }

    onSearchFormToggleClick(event) {
        this.$searchForm.toggleClass('active');
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'header_search_form_toggle' }}));
    }
}